import { Injectable } from '@angular/core';

type Translations = { [key: string]: string };

@Injectable()
export class TranslateService {
	private translations: Translations = {};

	// biome-ignore lint/complexity/noBannedTypes: suppressed due to migration - should be fixed
	public get(alias: string, args: Object = null, allowEmpty: boolean = false): string {
		if (window.sessionStorage['showAlias']) {
			return alias;
		}
		let translation = this.translations[alias];

		if (typeof translation === 'undefined' || typeof translation === 'object' || translation === '') {
			if (allowEmpty) return '';

			console.error('Missing translation: ' + alias);
			translation = alias;
		} else if (typeof args !== 'undefined') {
			for (var k in args) translation = translation.replace('{{' + k + '}}', args[k]);

			if (typeof translation === 'undefined' || typeof translation === 'object' || translation === '') {
				console.error('Missing translation: ' + alias);
			}

			if (typeof translation === 'undefined') {
				if (µ.isDevelopment) {
					let paths = alias.split('.');
					translation = paths[paths.length - 1] + '⚠';
				} else {
					translation = alias;
				}
			}

			return translation;
		}
	}

	public setTranslations(translations: Translations) {
		this.translations = translations;
	}
}
